export default __webpack_public_path__ + "media/images/icons_fc/outilsbleu-edd61bca8650cd56870f8b41d3ceb0c2.png";